import React from 'react';
import ReactDOM from 'react-dom/client';
import Navbar from '../Navbar/Navbar';
import HowItWorksTop from './HowItWorks Components/how-it-works-top/how-it-works-top';
import HowItWorksTiles from './HowItWorks Components/how-it-works-tiles/how-it-works-tiles';
import Bottom from '../HomePage/HomePageComponents/hompage-bottom/homepage-bottom';
import StickyBanner from '../HomePage/HomePageComponents/STICKY BANNER/stickybanner';


function HowItWorks() {

  
    return (
      <div className="how-it-works">
        <Navbar />
        <HowItWorksTop />
        <HowItWorksTiles />
        <Bottom />
        <StickyBanner />
      </div>
    );
  }
  
  export default HowItWorks;